var _defs, _g, _g2, _g3, _g4, _g5, _g6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMood(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100,
    preserveAspectRatio: "xMidYMid meet",
    style: {
      width: "100%",
      height: "100%",
      transform: "translate3d(0px, 0px, 0px)",
      contentVisibility: "visible"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "__lottie_element_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    x: 0,
    y: 0
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__lottie_element_2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,39.84600067138672,41.6150016784668)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,10.75,1.2039999961853027)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(244,176,101)",
    fillOpacity: 1,
    d: " M-9.545000076293945,-0.9549999833106995 C-10.071999549865723,-0.9549999833106995 -10.5,-0.5270000100135803 -10.5,0.0010000000474974513 C-10.5,0.527999997138977 -10.071999549865723,0.9549999833106995 -9.545000076293945,0.9549999833106995 C-9.545000076293945,0.9549999833106995 9.545999526977539,0.9549999833106995 9.545999526977539,0.9549999833106995 C10.072999954223633,0.9549999833106995 10.5,0.527999997138977 10.5,0.0010000000474974513 C10.5,-0.5270000100135803 10.072999954223633,-0.9549999833106995 9.545999526977539,-0.9549999833106995 C9.545999526977539,-0.9549999833106995 -9.545000076293945,-0.9549999833106995 -9.545000076293945,-0.9549999833106995z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,39.84600067138672,48.540000915527344)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,10.75,1.2039999961853027)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(244,176,101)",
    fillOpacity: 1,
    d: " M-9.545000076293945,-0.9549999833106995 C-10.071999549865723,-0.9549999833106995 -10.5,-0.5270000100135803 -10.5,0.0010000000474974513 C-10.5,0.527999997138977 -10.071999549865723,0.9549999833106995 -9.545000076293945,0.9549999833106995 C-9.545000076293945,0.9549999833106995 9.545999526977539,0.9549999833106995 9.545999526977539,0.9549999833106995 C10.072999954223633,0.9549999833106995 10.5,0.527999997138977 10.5,0.0010000000474974513 C10.5,-0.5270000100135803 10.072999954223633,-0.9549999833106995 9.545999526977539,-0.9549999833106995 C9.545999526977539,-0.9549999833106995 -9.545000076293945,-0.9549999833106995 -9.545000076293945,-0.9549999833106995z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,39.84600067138672,55.3589973449707)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,10.75,1.2050000429153442)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(244,176,101)",
    fillOpacity: 1,
    d: " M-9.545000076293945,-0.9549999833106995 C-10.071999549865723,-0.9549999833106995 -10.5,-0.5270000100135803 -10.5,0.0010000000474974513 C-10.5,0.527999997138977 -10.071999549865723,0.9549999833106995 -9.545000076293945,0.9549999833106995 C-9.545000076293945,0.9549999833106995 9.545999526977539,0.9549999833106995 9.545999526977539,0.9549999833106995 C10.072999954223633,0.9549999833106995 10.5,0.527999997138977 10.5,0.0010000000474974513 C10.5,-0.5270000100135803 10.072999954223633,-0.9549999833106995 9.545999526977539,-0.9549999833106995 C9.545999526977539,-0.9549999833106995 -9.545000076293945,-0.9549999833106995 -9.545000076293945,-0.9549999833106995z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,50.429691314697266,38.909000396728516)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,3.749000072479248,3.75)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(244,176,101)",
    fillOpacity: 1,
    d: " M0.004999999888241291,-3.5 C-1.6549999713897705,-3.5 -3.0450000762939453,-2.3450000286102295 -3.4049999713897705,-0.7940000295639038 C-3.4049999713897705,-0.7940000295639038 -3.499000072479248,-0.3059999942779541 -3.4790000915527344,0.18000000715255737 C-3.4570000171661377,0.7170000076293945 -3.313999891281128,1.1150000095367432 -3.313999891281128,1.1150000095367432 C-2.8480000495910645,2.500999927520752 -1.5379999876022339,3.5 0.004999999888241291,3.5 C1.5479999780654907,3.5 2.8580000400543213,2.500999927520752 3.3239998817443848,1.1150000095367432 C3.3239998817443848,1.1150000095367432 3.4609999656677246,0.6269999742507935 3.4839999675750732,0.11999999731779099 C3.499000072479248,-0.2160000056028366 3.4140000343322754,-0.7940000295639038 3.4140000343322754,-0.7940000295639038 C3.055000066757202,-2.3450000286102295 1.6649999618530273,-3.5 0.004999999888241291,-3.5z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,41.76766586303711,45.887001037597656)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,3.749000072479248,3.75)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(244,176,101)",
    fillOpacity: 1,
    d: " M0.004999999888241291,-3.5 C-1.6549999713897705,-3.5 -3.0450000762939453,-2.3450000286102295 -3.4049999713897705,-0.7940000295639038 C-3.4049999713897705,-0.7940000295639038 -3.499000072479248,-0.3059999942779541 -3.4790000915527344,0.18000000715255737 C-3.4570000171661377,0.7170000076293945 -3.313999891281128,1.1150000095367432 -3.313999891281128,1.1150000095367432 C-2.8480000495910645,2.500999927520752 -1.5379999876022339,3.5 0.004999999888241291,3.5 C1.5479999780654907,3.5 2.8580000400543213,2.500999927520752 3.3239998817443848,1.1150000095367432 C3.3239998817443848,1.1150000095367432 3.4609999656677246,0.6269999742507935 3.4839999675750732,0.11999999731779099 C3.499000072479248,-0.2160000056028366 3.4140000343322754,-0.7940000295639038 3.4140000343322754,-0.7940000295639038 C3.055000066757202,-2.3450000286102295 1.6649999618530273,-3.5 0.004999999888241291,-3.5z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,50.406497955322266,52.917999267578125)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,3.749000072479248,3.75)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(244,176,101)",
    fillOpacity: 1,
    d: " M0.004999999888241291,-3.5 C-1.6549999713897705,-3.5 -3.0450000762939453,-2.3450000286102295 -3.4049999713897705,-0.7940000295639038 C-3.4049999713897705,-0.7940000295639038 -3.499000072479248,-0.3059999942779541 -3.4790000915527344,0.18000000715255737 C-3.4570000171661377,0.7170000076293945 -3.313999891281128,1.1150000095367432 -3.313999891281128,1.1150000095367432 C-2.8480000495910645,2.500999927520752 -1.5379999876022339,3.5 0.004999999888241291,3.5 C1.5479999780654907,3.5 2.8580000400543213,2.500999927520752 3.3239998817443848,1.1150000095367432 C3.3239998817443848,1.1150000095367432 3.4609999656677246,0.6269999742507935 3.4839999675750732,0.11999999731779099 C3.499000072479248,-0.2160000056028366 3.4140000343322754,-0.7940000295639038 3.4140000343322754,-0.7940000295639038 C3.055000066757202,-2.3450000286102295 1.6649999618530273,-3.5 0.004999999888241291,-3.5z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMood);
export default __webpack_public_path__ + "static/media/mood.eb6c2989be7a820e148282dc32eab459.svg";
export { ForwardRef as ReactComponent };